import { Injectable,OnInit } from '@angular/core';
import { Router, CanActivate,Route,Params,ActivatedRoute  } from '@angular/router';
import { environment } from '../../environments/environment';
import { RestApiService } from '../Services/rest-api-service';
import { HttpClient } from '@angular/common/http';
import { MyProfileData } from '../Model/api-model';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class AmGuardService implements CanActivate {
  isProduction: boolean;
  environment: string;
  amurlForAuth:string;
  private id: string;
  private token: string;
  private authFlag:boolean;
  code_verifier:string;
  code_challenge:string;

  constructor(private httpClient: HttpClient, private restApi: RestApiService, private route: ActivatedRoute,public router: Router) {
    
   
  
    
     

  } 



  canActivate(): boolean {

    
    this.token=localStorage.getItem('devportal_apic_token');
    //console.log('token'+this.token);

      if(this.token==null || this.token=='login'){
        localStorage.removeItem("devportal_id_token")
        this.authFlag=true;
      }
      else{
        this.authFlag=false;
      }





    
   // console.log(this.authFlag);
    if (this.authFlag) {

     // console.log("inside do login()");      
      
      
      this.code_verifier=this.generateCodeVerifier();  
      
     // console.log("this.code_verifier " +this.code_verifier)
      
      this.code_challenge= this.generateCodeChallenge(this.code_verifier);
   
      //console.log("this.this.code_challenge " +this.code_challenge)
     
    

      //localStorage.setItem("code_verifier",this.code_verifier);
      sessionStorage.setItem("code_verifier",this.code_verifier);

      this.environment = environment.getEnvironment();
      this.isProduction = environment.production;
      this.amurlForAuth = environment.getAmurl()+environment.getAmClientId()+"&scope="+environment.getScope()+"&redirect_uri="+environment.getRedirecturi()+"&code_challenge="+this.code_challenge+"&code_challenge_method=S256a";
     
      document.location.href= this.amurlForAuth; 

      return false;
    }
    //console.info("Env true"+this.environment+this.amurlForAuth);
    return true;
  }
 
  generateCodeVerifier() {
    const code_verifier = this.generateRandomString(128); 
    
    return code_verifier;
  }

  generateRandomString(length) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  generateCodeChallenge(code_verifier){
    
    let code_challenge;
    return  code_challenge = this.base64URL(CryptoJS.SHA256(code_verifier))
  }


  base64URL(string) {
    return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
  }



  
}